import { React, useState } from "react";
import styles from "./forgotPass.module.css";
import logo from "./logo.png";
import { Link } from "react-router-dom";
import axios from "axios";

const apiUrl = process.env.REACT_APP_URL;

const ForgotPassword = () => {
  /* The Forgot Password Page is a public page which allows the user to enter an email address registered with his / her account, and get a password recovery link to his / her email address. */

  const [email, setEmail] = useState("");
  const [successfullySent, setSuccessfullySent] = useState(false);
  const [emailDoesNotExist, setEmailDoesNotExist] = useState(false);

  /**  Function to validate the entered mail - check if the entered email address is
   * associated with an account on the website. If so, a password recovery link is sent to the email address.
   * */
  async function handleValidateEmail(e) {
    e.preventDefault();

    try {
      const res = await axios.get(`${apiUrl}/auth/email_check/${email}`);

      if (res.status === 200 && res.data.success) {
        await axios.post(`${apiUrl}/auth/send_recovery_email`, {
          email,
        });
        setSuccessfullySent(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Email does not exist
        setEmailDoesNotExist(true);
      } else {
        console.error("Email error", error);
      }
    }
  }

  /**
   * Handle change in the email input field
   */
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Clear the error message if the input is empty
    if (value === "") {
      setEmailDoesNotExist(false);
    }
  };
  return (
    <main className={styles.main}>
      {!successfullySent ? (
        <form className={styles.form} onSubmit={handleValidateEmail}>
          <figure className={styles.logoFig}>
            <img src={logo} alt="Logo" />
          </figure>

          {/* Username input */}
          <div className={styles.inputContainer}>
            <input
              type="text"
              name="userEmail"
              placeholder="Enter your email address"
              className={styles.inputWithIcon}
              onChange={handleEmailChange}
              required
            />
          </div>

          <button className={styles.recoveryBtn} type="submit">
            Receive recovery link
          </button>
          {emailDoesNotExist && (
            <p className={styles.error}>Email is invalid</p>
          )}
          <div className={styles.changeMode}>
            <Link to="/login" className={styles.customLink}>
              Back to login
            </Link>
          </div>
        </form>
      ) : (
        <p className={styles.form}>Your request was sent successfully</p>
      )}
    </main>
  );
};

export default ForgotPassword;
